<mbm-modal id="app-update-modal" titleKey="pwa.update.title" [showCloseButton]="false">
  <ng-container slot="modal-content">
    <p id="app-update-message" class="app-update-message">{{ 'pwa.update.message' | translate }}</p>
  </ng-container>

  <ng-container slot="modal-footer">
    <div class="app-update-actions">
      <mbm-button id="app-update-reload-btn" variant="primary" textKey="pwa.update.reload" (buttonClick)="onReload()"></mbm-button>
    </div>
  </ng-container>
</mbm-modal>
